import toast from "react-hot-toast";

export const showErrorToast = (err: any) => {
  let message = "Unexpected Error!";
  try {
    message = err.response.data.message;
  } catch {}
  toast.error(message);
};
